import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Tag } from 'antd'

import {
  getMemberApproveStatusMap,
  MemberApproveStatus
} from '../../enums/MemberApproveStatus'

import { MemberApproveStatusTagProps } from './interface'

export const MemberApproveStatusTag = ({
  approveStatus,
  hideSuccessStatus = true
}: MemberApproveStatusTagProps) => {
  const approveStatusMap = getMemberApproveStatusMap(approveStatus)

  return hideSuccessStatus &&
    approveStatus === MemberApproveStatus.SUCCESS ? null : (
    <Tag color={approveStatusMap.color}>
      <ExclamationCircleOutlined />
      {approveStatusMap.text}
    </Tag>
  )
}
